import Mask from './components/mask';
import { setCookie, getCookie } from './helper/cookie';
import { disableScroll, enableScroll } from './helper/helper';
class PopupManager {
	constructor() {
		this.popups = [...document.querySelectorAll('.hpy-popup')];
		this.mask = new Mask('menu', {}, this.close.bind(this));
		this.state = {
			currentPopup: null,
			timelines: {},
			shown: [],
			events: []
		}

		if (!this.popups.length) return;

		this.popups.forEach(popup => {
			this.setupPopupConditions(popup);
		});
	}

	setupPopupConditions(popup) {
		const condition = popup.dataset.condition;

		// don't setup any of the cookie display conditions if we only show it onces
		if (this.disablePopupViaCookie(popup)) {
			return;
		}

		if (!condition) return;

		this.setupClose(popup);
		this.setupAnimation(popup);

		switch (condition) {
			case 'on-click':
				this.onClick(popup);
				break;
			case 'on-load':
				this.onLoad(popup);
				break;
			case 'on-scroll':
				this.onScroll(popup);
				break;
		}
	}

	onClick(popup) {
		const element = document.querySelector(popup.dataset.selector);
		if (!element) {
			console.error('Popup selector not found');
			return;
		}

		element.addEventListener('click', (e) => {
			e.preventDefault();
			if (popup.dataset.selector.includes('footer--newsletter--signup-form')) {
				let form = element.closest('form');
				if (form) {
					let email = form.querySelector('input[type="email"]');
					if (email && email.value.trim()) {
						popup.querySelector('input[type="email"]').value = email.value.trim();
					}
				}
			}
			this.open(popup);
		});
	}

	onLoad(popup) {
		window.addEventListener('load', () => {
			this.open(popup, true);
		});
	}

	onScroll(popup) {
		window.addEventListener('scroll', () => {
			// get window scroll percentage from top of the page
			const scrollPercentage = (window.scrollY / (document.body.offsetHeight - window.innerHeight)) * 100;

			// if the scroll percentage is higher than the scroll threshold, open the popup
			if (scrollPercentage > parseFloat(popup.dataset.scroll)) {
				this.open(popup, true);
			}
		});
	}

	open(popup, oncePerPage) {

		if (this.disablePopupViaCookie(popup) || (oncePerPage && this.state.shown.includes(popup.id))) {
			return;
		}

		if (popup.dataset.once === 'true') {
			setCookie(popup.id + '-show-once', 'true', 0);
		};

		this.state.currentPopup = popup

		document.documentElement.style.overflow = 'hidden';
		disableScroll();
		this.state.timelines[this.state.currentPopup.id].play();
		this.state.shown.push(popup.id);
	}

	close() {
		if (!this.state.currentPopup) {
			return;
		}

		document.documentElement.style.overflow = 'visible';
		enableScroll();
		this.state.timelines[this.state.currentPopup.id].reverse();
		this.mask.hide();
		this.state.currentPopup = null;
	}

	setupAnimation(popup) {
		const timeline = gsap.timeline({ paused: true });
		const options = {
			opacity: 1,
			display: 'flex',
			duration: 0.3,
			onStart: () => {
				popup.style.display = 'flex';
				this.mask.show();
			}
		};

		const delay = popup.dataset?.delay ? `=+${parseInt(popup.dataset.delay) / 1000}` : '';

		timeline.set(popup, { opacity: 0, display: 'none' });
		timeline.to(popup, options, delay);

		this.state.timelines[popup.id] = timeline;

	}

	setupClose(popup) {
		popup.querySelector('.hpy-popup--close').addEventListener('click', () => {
			this.close();
		});

		window.addEventListener('keydown', (event) => {
			if (event.key === 'Escape' && this.state.currentPopup) {
				this.close();
			}
		});
	}

	disablePopupViaCookie(popup) {
		if (popup.dataset.once === 'true') {
			const cookie = getCookie(popup.id + '-show-once');
			return null !== cookie;
		}

		return false;
	}
}

new PopupManager;